import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Spinner } from 'reactstrap';
import { Search, ChevronDown, ChevronUp, UserCheck } from 'react-feather';
import Input from '../../components/ui/Input';
import Select from '../../components/ui/Select';
import Table from '../../components/ui/Table';
import NuevaMatricula from '../../components/auto-mat/NuevaMatricula';
import presupuestosApiService from '../../services/http/presupuestosApiService';
import { getItem, setItem, removeItem, STORAGE_KEYS } from '../../services/storage';
import config from '../../config';
import colors from '../../theme/colors';
import logger from '../../services/logger';

const CENTROS = [
  { value: 'CEDETECGROUP', label: 'Todos' },
  { value: 'CEDESCA', label: 'CEDESCA' },
  { value: 'CNTEC', label: 'CNTEC' },
];

const NuevoPresupuesto = () => {
  const [searchParams] = useSearchParams();
  const skipSearch = searchParams.get('skipSearch') === 'true';
  const storedStudent = getItem(STORAGE_KEYS.STUDENT);
  const [showFilters, setShowFilters] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [results, setResults] = useState([]);
  const [searched, setSearched] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState(
    skipSearch && storedStudent?.id ? storedStudent : null,
  );
  const [filters, setFilters] = useState({
    centro: 'CEDETECGROUP',
    id: '',
    ccodcli: '',
    nombre: '',
    apellidos: '',
    dni: '',
    email: '',
  });

  const handleChange = (e) => {
    setFilters((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSearch = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const data = await presupuestosApiService.buscarLeads(filters);
      setResults(Array.isArray(data?.rows) ? data.rows : Array.isArray(data) ? data : []);
    } catch (error) {
      logger.error('Error buscando leads:', error);
      setResults([]);
    } finally {
      setIsLoading(false);
      setSearched(true);
    }
  };

  const handleSelect = (lead) => {
    if (removeItem) removeItem(STORAGE_KEYS.STUDENT);
    // Si el registro tiene ccodcli es un alumno existente (isLead=false);
    // si solo tiene Id, es un lead puro (isLead=true). Si vienen los dos,
    // damos preferencia a ccodcli porque el alumno ya está dado de alta.
    const ccodcli = lead.ccodcli || lead.Ccodcli || lead.CCODCLI;
    const isLead = !ccodcli;
    const studentId = ccodcli || lead.Id;
    setItem(STORAGE_KEYS.STUDENT, {
      id: studentId,
      isLead,
      nombre: lead.Nombre || '',
      apellidos: lead.Apellidos || '',
      empresaId: lead.sede || 'CEDESCA',
    });
    setSelectedStudent(lead);
  };

  if (selectedStudent) {
    return (
      <NuevaMatricula
        variant={config.REACT_APP_ORIGIN}
        deployment={config.REACT_APP_DEPLOYMENT}
        mode="presupuesto"
      />
    );
  }

  return (
    <div>
      <div style={{ marginBottom: '16px' }}>
        <h1 style={{ fontSize: '1.25rem', fontWeight: 700, color: '#111827', margin: 0 }}>
          Nuevo presupuesto
        </h1>
        <p style={{ color: '#9ca3af', marginTop: '2px', marginBottom: 0, fontSize: '0.8rem' }}>
          Selecciona el alumno para crear el presupuesto
        </p>
      </div>
      <form onSubmit={handleSearch}>
        <div
          style={{
            backgroundColor: '#fff',
            borderRadius: '12px',
            border: '1px solid #e5e7eb',
            boxShadow: '0 1px 3px rgb(0 0 0 / 0.06)',
            overflow: 'visible',
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: '12px 16px',
              borderBottom: showFilters ? '1px solid #f3f4f6' : 'none',
            }}
          >
            <button
              type="button"
              onClick={() => setShowFilters(!showFilters)}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                fontSize: '0.8rem',
                fontWeight: 600,
                color: '#374151',
                padding: '4px 8px',
                borderRadius: '6px',
              }}
            >
              <Search size={15} style={{ color: '#9ca3af' }} />
              Filtros
              {showFilters ? (
                <ChevronUp size={14} style={{ color: '#9ca3af' }} />
              ) : (
                <ChevronDown size={14} style={{ color: '#9ca3af' }} />
              )}
            </button>
            <button
                type="submit"
                disabled={isLoading}
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '5px',
                  padding: '6px 14px',
                  fontSize: '0.75rem',
                  fontWeight: 600,
                  borderRadius: '6px',
                  border: 'none',
                  backgroundColor: colors.primary,
                  color: '#fff',
                  cursor: isLoading ? 'not-allowed' : 'pointer',
                  opacity: isLoading ? 0.5 : 1,
                  transition: 'all 0.15s',
                }}
              >
                {isLoading ? (
                  <Spinner style={{ height: '13px', width: '13px' }} />
                ) : (
                  <Search size={13} />
                )}
                Buscar
              </button>
          </div>

          {showFilters && (
            <div
              style={{
                padding: '16px',
                opacity: isLoading ? 0.5 : 1,
                pointerEvents: isLoading ? 'none' : 'auto',
                transition: 'opacity 0.2s',
              }}
            >
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(4, 1fr)',
                  gap: '12px',
                  marginBottom: '12px',
                }}
              >
                <Select
                  label="Centro"
                  name="centro"
                  id="centroNuevoPresupuesto"
                  value={filters.centro}
                  onChange={handleChange}
                  disabled={isLoading}
                  options={CENTROS}
                />
                <Input
                  label="ID Lead"
                  type="text"
                  name="id"
                  id="idLeadNuevoPresupuesto"
                  placeholder="ID"
                  value={filters.id}
                  onChange={handleChange}
                  disabled={isLoading}
                />
                <Input
                  label="CCODCLI"
                  type="text"
                  name="ccodcli"
                  id="ccodcliNuevoPresupuesto"
                  placeholder="Código alumno"
                  value={filters.ccodcli}
                  onChange={handleChange}
                  disabled={isLoading}
                />
                <Input
                  label="Nombre"
                  type="text"
                  name="nombre"
                  id="nombreNuevoPresupuesto"
                  placeholder="Nombre"
                  value={filters.nombre}
                  onChange={handleChange}
                  disabled={isLoading}
                />
              </div>
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(3, 1fr)',
                  gap: '12px',
                }}
              >
                <Input
                  label="Apellidos"
                  type="text"
                  name="apellidos"
                  id="apellidosNuevoPresupuesto"
                  placeholder="Apellidos"
                  value={filters.apellidos}
                  onChange={handleChange}
                  disabled={isLoading}
                />
                <Input
                  label="DNI / NIE / NIF"
                  type="text"
                  name="dni"
                  id="dniNuevoPresupuesto"
                  placeholder="Documento"
                  value={filters.dni}
                  onChange={handleChange}
                  disabled={isLoading}
                />
                <Input
                  label="Email"
                  type="email"
                  name="email"
                  id="emailNuevoPresupuesto"
                  placeholder="Correo"
                  value={filters.email}
                  onChange={handleChange}
                  disabled={isLoading}
                />
              </div>
            </div>
          )}
        </div>
      </form>

      {searched && (
        <div style={{ marginTop: '16px' }}>
          {results.length > 0 ? (
            <Table
              columns={[
                { Header: 'ID Lead', accessor: 'Id' },
                { Header: 'CCODCLI', accessor: 'ccodcli' },
                { Header: 'Nombre', accessor: 'Nombre' },
                { Header: 'Apellidos', accessor: 'Apellidos' },
                { Header: 'DNI', accessor: 'DNI' },
                { Header: 'Email', accessor: 'Correo' },
                { Header: 'Móvil', accessor: 'Movil' },
                { Header: 'Sede', accessor: 'sede' },
                {
                  Header: '',
                  accessor: 'actions',
                  sortable: false,
                  // eslint-disable-next-line react/prop-types
                  Cell: ({ original }) => (
                    <button
                      type="button"
                      onClick={() => handleSelect(original)}
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '4px',
                        padding: '4px 10px',
                        fontSize: '0.7rem',
                        fontWeight: 600,
                        borderRadius: '6px',
                        border: 'none',
                        backgroundColor: colors.primary,
                        color: '#fff',
                        cursor: 'pointer',
                      }}
                    >
                      <UserCheck size={13} /> Seleccionar
                    </button>
                  ),
                },
              ]}
              data={results}
              defaultPageSize={10}
              showPaginationBottom
              className="-striped -highlight text-center"
            />
          ) : (
            <p
              style={{
                color: '#6b7280',
                fontSize: '0.85rem',
                textAlign: 'center',
                marginTop: '24px',
              }}
            >
              No se han encontrado leads.
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default NuevoPresupuesto;
